import { ChartedItem } from '@principle-theorem/principle-core';
import {
  ChartItemDisplayType,
  isChartedCondition,
  type IChartedItem,
  type IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';

export function getChartItemDisplayType(
  item: IChartedItem,
  chartingAs?: WithRef<IStaffer>
): ChartItemDisplayType {
  if (isChartedCondition(item)) {
    if (ChartedItem.isResolved(item)) {
      return ChartItemDisplayType.ResolvedCondition;
    }
    return ChartItemDisplayType.CurrentCondition;
  }

  // Treatment
  if (!ChartedItem.isResolved(item)) {
    return ChartItemDisplayType.ProposedTreatment;
  }

  // This is for adding existing treatments to the chart, however we don't have it accessible in the UI yet.
  if (!item.resolvedBy || !chartingAs) {
    return ChartItemDisplayType.ExistingTreatment;
  }

  return ChartItemDisplayType.CompletedTreatment;
}
